import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=4b522b5b&scoped=true&"
import script from "./StatusIndicator.vue?vue&type=script&lang=js&"
export * from "./StatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=4b522b5b&prod&scoped=true&lang=scss&"
import style1 from "./StatusIndicator.vue?vue&type=style&index=1&id=4b522b5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b522b5b",
  null
  
)

export default component.exports